import toggleScroll from './hideScroll';

export default () => {
  //E-mail Ajax Send
  $('.form-send').on('submit', (e) => {
    e.preventDefault();

    const $form = $(e.currentTarget);

    $.ajax({
      type: "POST",
      url: WPJS.ajaxUrl + '?action=send_mail',
      data: $form.serialize(),
      success: function(msg) {
        const $activePopup = $('.popup--active');

        if ($activePopup) {
          $activePopup.removeClass('popup--active');
        } else{
          toggleScroll();
        }
      
        $('.popup-thanks').addClass('popup--active');

      },
      error: function() {
        alert('Что-то пошло не так, пожалуйста попробуйте снова или перезвоните по номеру +7 (495) 266-69-58');
      },
      complete: function() {

        setTimeout(function() {
          $form.trigger("reset");
        }, 1000);

      }
    });
  });
  //Form end
};